import { render, staticRenderFns } from "./PulpitBezStatusu.vue?vue&type=template&id=a3bf8738&scoped=true&"
import script from "./PulpitBezStatusu.vue?vue&type=script&lang=js&"
export * from "./PulpitBezStatusu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bf8738",
  null
  
)

export default component.exports